import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MainContent } from "../../../styled-components/Layout";
import { IconButton } from "../../../styled-components";
import {
  faPlusSquare,
  faPenSquare,
  faMinusSquare
} from "@fortawesome/free-solid-svg-icons";

const MenuContainer = styled(MainContent)`
  background: ${props => props.theme.savedItems.menuBackground};
  padding: 0.25rem 0.5rem;
  min-height: 1.5rem;
  display: flex;
`;

const FolderIcon = styled.div`
  color: ${props => props.theme.folder};
`;

const MenuButton = styled(IconButton)`
  margin-right: 0.5rem;
  filter: ${props => (props.disabled ? "grayscale(100%)" : "none")};
`;

const MenuButtonIcon = styled.img``;

const AddFolderIcon = styled.div`
  color: ${props => props.theme.colors.green};
`;

const EditFolderIcon = styled.div`
  color: ${props => props.theme.colors.yellow};
`;

const DeleteFolderIcon = styled.div`
  color: ${props => props.theme.colors.red};
`;

class FolderListMenu extends Component {
  handleActionClicked = action => {
    if (this.props.onAction && this.props.enabled) {
      this.props.onAction(action);
    }
  };

  render() {
    const { add, remove, rename, enabled } = this.props;
    return (
      <MenuContainer>
        <MenuButton
          disabled={!add || !enabled}
          onClick={() => this.handleActionClicked("add")}
        >
          <IconButton>
            <AddFolderIcon>
              <FontAwesomeIcon fixedWidth icon={faPlusSquare} size="lg" />
            </AddFolderIcon>
          </IconButton>
        </MenuButton>
        <MenuButton
          disabled={!rename || !enabled}
          onClick={() => this.handleActionClicked("rename")}
        >
          <IconButton>
            <EditFolderIcon>
              <FontAwesomeIcon fixedWidth icon={faPenSquare} size="lg" />
            </EditFolderIcon>
          </IconButton>
        </MenuButton>
        <MenuButton
          disabled={!remove || !enabled}
          onClick={() => this.handleActionClicked("delete")}
        >
          <DeleteFolderIcon>
            <FontAwesomeIcon size="lg" fixedWidth icon={faMinusSquare} />
          </DeleteFolderIcon>
        </MenuButton>
      </MenuContainer>
    );
  }
}

FolderListMenu.defaultProps = {
  onAction: null,
  enabled: false,
  add: false,
  remove: false,
  rename: false
};

FolderListMenu.propTypes = {
  onAction: PropTypes.func,
  add: PropTypes.bool,
  remove: PropTypes.bool,
  rename: PropTypes.bool,
  enabled: PropTypes.bool
};
export default FolderListMenu;



// WEBPACK FOOTER //
// ./app/components/SavedItems/FolderTree/FolderTreeMenu.js